module.exports = __webpack_public_path__ + "img/background_medio_web.a8bec7e8.webp";